import script from "./ProductInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductInfo.vue?vue&type=script&setup=true&lang=js"

import "./ProductInfo.vue?vue&type=style&index=0&id=b79e69f2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b79e69f2"]])

export default __exports__